import { defineComponent as _defineComponent } from 'vue'
import { PropType } from "vue";
import InlineSvg from "vue-inline-svg";


const __default__ = {
  name: "FavoriteStatusButton",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  shouldBeFilled: {
    type: Boolean,
    default: false,
  },
  favoritedIcon: {
    type: String as PropType<any>,
    default: require("@/assets/icons/star-thin-fill.svg"),
  },
  unFavoritedIcon: {
    type: String as PropType<any>,
    default: require("@/assets/icons/star-thin.svg"),
  },
},
  emits: ["onClick"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();



const emit = __emit;

const emitOnClick = (shouldBeFilled: boolean) => {
  emit("onClick", shouldBeFilled);
};

const __returned__ = { emit, emitOnClick, get InlineSvg() { return InlineSvg } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})